class PhoneSlider extends HTMLElement {
  connectedCallback() {
    const emblaNode = this.querySelector('.embla');
    const options = { loop: false };
    this.embla = EmblaCarousel(emblaNode, options);

    const navButtons = this.querySelectorAll('.desktop-nav button');
    navButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        try {
          this.embla.scrollTo(index);
        } catch (error) {
          console.error('Error scrolling to slide:', error);
          // Fallback: try to select the slide
          this.embla.selectSlide(index);
        }
        this.updateActiveState(index);
      });
    });

    // Add prev/next button handlers
    const prevButton = this.querySelector('button.prev');
    const nextButton = this.querySelector('button.next');

    const updatePrevNextButtons = () => {
      if (!prevButton || !nextButton) return;

      const canScrollPrev = this.embla.canScrollPrev();
      const canScrollNext = this.embla.canScrollNext();

      prevButton.disabled = !canScrollPrev;
      nextButton.disabled = !canScrollNext;

      // Optional: Update visual state
      prevButton.style.opacity = canScrollPrev ? '1' : '0.5';
      nextButton.style.opacity = canScrollNext ? '1' : '0.5';
    };

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        this.embla.scrollPrev();
        updatePrevNextButtons();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        this.embla.scrollNext();
        updatePrevNextButtons();
      });
    }

    // Listen for slide changes and update states
    this.embla.on('select', () => {
      const index = this.embla.selectedScrollSnap();
      this.updateActiveState(index);
      updatePrevNextButtons();
    });

    // Initial states
    this.updateActiveState(0);
    updatePrevNextButtons();
  }

  updateActiveState(activeIndex) {
    const navButtons = this.querySelectorAll('.nav button');
    navButtons.forEach((button, index) => {
      if (index === activeIndex) {
        button.classList.add('tw-bg-primary-soft-black', 'tw-text-white');
        button.classList.remove('tw-bg-primary-white', 'tw-text-primary-mid-black');
      } else {
        button.classList.remove('tw-bg-primary-mid-black', 'tw-text-white');
        button.classList.add('tw-bg-primary-white', 'tw-text-primary-mid-black');
      }
    });
  }
}

customElements.define('phone-slider', PhoneSlider);
